import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var GoogleDriveDark = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    svgColor: "#fff",
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.38 2.5 13.796 28.595h-.036v.062L6.815 41.105 0 29.62 15.079 2.5h13.3ZM44 28.595 29.675 2.5 22.87 14.38l7.545 14.215H44ZM14.349 29.62H44l-6.05 11.88H7.698l6.65-11.88Z",
    svgColor: "#302C41"
  }));
});
GoogleDriveDark.displayName = 'GoogleDriveDark';
GoogleDriveDark.defaultProps = {
  'aria-label': 'GoogleDriveDark'
};
export default GoogleDriveDark;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/GoogleDriveDark.js
// module id = 2952
// module chunks = 11